import styled from "styled-components"

export const Container = styled.div`
  display: ${(props) => (props.show ? "flex" : "none")};
  width: 100%;
  height: 100%;
  background-color: #00000033;
  position: absolute;
  justify-content: center;
  align-items: center;
  z-index: 99;
`
